import { getActiveChannel, getStoredUser } from '../authentication/utils'
import {post} from '../utils'

export default host => (id, data) => post(`${host}${!getStoredUser() ? `/public` : ''}/channels/${getActiveChannel()}/banners/${id}/view`, JSON.stringify(data))
